import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Title } from '@siftscience/focus-components/text'
import {
  PaginationPageSelector,
  RowCountSelector,
  createRowCountItems
} from '@siftscience/focus-components/enhanced_pagination'
import { ImageCardProps } from '../types'
import ImageCard from './ImageCard'
import Loader from '../../DET-edit-additions/loader'

const useStyles = makeStyles(() => ({
  container: {
    padding: '24px',
    display: 'grid',
    marginTop: '84px',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px'
  },
  selectContainer: {
    padding: '24px',
    display: 'grid',
    marginTop: '0',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px'
  },
  empty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '32px'
  },
  paginationWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 24px'
  }
}))

interface ImagesListProps {
  images: ImageCardProps[]
  isSelected: (id: string) => boolean
  onToggleSelect: (id: string) => void
  handleOpenDetails?: (id: string) => void
  onDelete?: (id: string) => void
  onEvidenceChange?: (id: string) => void
  isLoading: boolean
  merchantId: number
  totalCount: number
  perPage: number
  currentPage: number
  onPageChange: (value: number) => void
  onPerPageChange: (value: number) => void
}

const ImagesList = ({
  images,
  isSelected,
  onToggleSelect,
  handleOpenDetails,
  onDelete,
  onEvidenceChange,
  onPageChange,
  onPerPageChange,
  merchantId,
  isLoading,
  totalCount,
  perPage,
  currentPage
}: ImagesListProps) => {
  const classes = useStyles()
  if (!merchantId) {
    return (
      <div className={classes.empty}>
        <Title size="large">You need to select Merchant to see images</Title>
      </div>
    )
  }
  if (isLoading) {
    return (
      <div className={classes.empty}>
        <Loader />
      </div>
    )
  }
  if (!images.length) {
    return (
      <div className={classes.empty}>
        <Title size="large">There are not images yet</Title>
      </div>
    )
  }
  return (
    <>
      <div
        className={
          onEvidenceChange ? classes.container : classes.selectContainer
        }
      >
        {images.map(imageData => (
          <ImageCard
            key={imageData.id}
            {...imageData}
            handleOpenDetails={handleOpenDetails}
            selected={isSelected(imageData.id)}
            onToggleSelect={() => onToggleSelect(imageData.id)}
            onDelete={onDelete}
            onEvidenceChange={onEvidenceChange}
          />
        ))}
      </div>
      <div className={classes.paginationWrapper}>
        <div />
        <PaginationPageSelector
          total={Math.ceil(totalCount / perPage)}
          current={currentPage}
          onPageChange={onPageChange}
          onPrevPage={onPageChange}
          onNextPage={onPageChange}
        />
        <RowCountSelector
          items={createRowCountItems('items', [5, 10, 25, 50, 100, 200])}
          currentItem={perPage}
          onSelectItem={onPerPageChange}
        />
      </div>
    </>
  )
}

export default ImagesList
